import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class ChoiceOtherBehaviour extends AbstractDataAttributeBehaviour {
  attrNames = {
    'container': 'data-choice-other',
    'target': 'data-choice-other-target',
    'other_choice': 'data-choice-other-value',
    'target_selector': 'data-choice-other-input'
  }

  getContainerSelector() {
    return '[' + this.attrNames.container + ']';
  }

  getTargetSelector(name) {
    return `[${this.attrNames.target_selector}="${name}"]`;
  }

  toggleClass(toggleState, target) {
    if (!target) return false;

    toggleState
      ? target.classList.remove('hide')
      : target.classList.add('hide');
  }

  initContainer(container) {
    container.addEventListener('change', e => {
      let otherChoiceValue = container.getAttribute(this.attrNames.other_choice);
      let value = container.value;
      let target = container.getAttribute(this.attrNames.target);
      let targetElement = document.querySelector(this.getTargetSelector(target));

      this.toggleClass(
        (value === otherChoiceValue && container.checked),
        targetElement
      );
    });
  }
}